import { GeneralTreatingPhysicianFieldController } from "./general-treating-physician-field-controller";

export class TreatingPhysicianNrFieldController extends GeneralTreatingPhysicianFieldController {}
